import { memo, ReactNode } from 'react'
// Reward type icons
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents'
import LocationOnIcon from '@mui/icons-material/LocationOn'
import TextSnippetIcon from '@mui/icons-material/TextSnippet'
import HeadphonesIcon from '@mui/icons-material/Headphones'
import VideoLibraryIcon from '@mui/icons-material/VideoLibrary'
import ImageIcon from '@mui/icons-material/Image'
import LockOpenIcon from '@mui/icons-material/LockOpen'
import TimerIcon from '@mui/icons-material/Timer'
import ArticleIcon from '@mui/icons-material/Article'
import GroupIcon from '@mui/icons-material/Group'
import BaseNode from './BaseNode'
import { WorkflowNodeData } from '@store/workflowStore'

// Map reward types to their icons and labels (matches WorkflowToolbar.tsx)
const rewardTypeConfig: Record<string, { icon: ReactNode; label: string }> = {
  location: { icon: <LocationOnIcon fontSize="small" />, label: 'Location' },
  text_clue: { icon: <TextSnippetIcon fontSize="small" />, label: 'Text Clue' },
  audio: { icon: <HeadphonesIcon fontSize="small" />, label: 'Audio Player' },
  video: { icon: <VideoLibraryIcon fontSize="small" />, label: 'Video Player' },
  image: { icon: <ImageIcon fontSize="small" />, label: 'Image Display' },
  unlock_adventure: { icon: <LockOpenIcon fontSize="small" />, label: 'Unlock Adventure' },
  time_modifier: { icon: <TimerIcon fontSize="small" />, label: 'Time Bonus/Penalty' },
  formatted_message: { icon: <ArticleIcon fontSize="small" />, label: 'Formatted Message' },
  group_membership: { icon: <GroupIcon fontSize="small" />, label: 'Group Membership' },
}

// Default icon and label for unknown reward types
const defaultRewardConfig = { icon: <EmojiEventsIcon fontSize="small" />, label: 'Reward' }

interface LocationNodeProps {
  id: string
  data: WorkflowNodeData
  selected?: boolean
}

function LocationNode(props: LocationNodeProps) {
  const { data } = props

  const rewardType = data.rewardType
  const config = rewardType ? rewardTypeConfig[rewardType] || defaultRewardConfig : defaultRewardConfig

  return (
    <BaseNode
      {...props}
      icon={config.icon}
      headerLabel={config.label}
      showTargetHandle={true}
      showSourceHandle={true}
    />
  )
}

export default memo(LocationNode)
